export const vadeGunTypes = {
  GECMIS: "Geçmiş",
  GELECEK: "Gelecek",
  HEPSI: "Hepsi",
};
